import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import * as Sentry from "@sentry/react";

import App from "./App";
import ThemeProvider from "./theme/provider";
import { isCqc } from "./utilities/cqc";
import styled from "styled-components";

if (process.env.NODE_ENV === "production")
  Sentry.init({
    dsn:
      "https://1750a2a2228a442280c036fd2fb9cdb2@o380479.ingest.sentry.io/5644437",
  });

const FontDiv = styled.div`
  font-family: ${isCqc ? '"Montserrat", sans-serif' : '"Spartan", sans-serif'};
`;

ReactDOM.render(
  <FontDiv>
    <BrowserRouter>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </FontDiv>,
  document.getElementById("root")
);
